<h1 class="message" [ngClass]="error && !error.emailAlreadyVerified ? 'error' : 'success'">
    {{ emailVerificationResult }}
</h1>

<button class="cta-button" (click)="onAfterVerificationCtaClick()">
    {{ afterVerificationCta }}
</button>
